import React from 'react';
import * as styles from './separator.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Separator = _ref => {
  var className = _ref.className;
  return ___EmotionJSX("div", {
    className: className,
    css: styles.separator
  });
};
export default Separator;